import { Component } from "react";
import onClickOutside from "react-onclickoutside";

import { KibelaSymbol } from "../shared/kibela_symbol";

import type { PostButtonProps } from "./PostButton";
import { PostButtonDropdown } from "./PostButtonDropdown";

interface State {
  isMenuOpen: boolean;
}

class PostButtonSpBase extends Component<PostButtonProps, State> {
  constructor(props) {
    super(props);
    this.state = {
      isMenuOpen: false,
    };
  }

  handleClickOutside() {
    this.setState({ isMenuOpen: false });
  }

  render() {
    return (
      <div className="dropdownBox-container button-withDropdown-container">
        <span onClick={() => this.setState({ isMenuOpen: !this.state.isMenuOpen })} className={"is-button-note"}>
          <KibelaSymbol id="post" />
        </span>
        {this.state.isMenuOpen && (
          <PostButtonDropdown
            currentUserAccount={this.props.currentUserAccount}
            canManageTemplates={this.props.canManageTemplates}
            templates={this.props.templates}
          />
        )}
      </div>
    );
  }
}

export const PostButtonSP = onClickOutside(PostButtonSpBase);
